import name from './name'

const selectSliceData = state => state[name]
const selectAuthors = state => selectSliceData(state).authors
const selectAuthor = state => selectSliceData(state).author
const selectAuthorLoaded = state => selectSliceData(state).authorLoaded
const selectAuthorsLoaded = state => selectSliceData(state).authorsLoaded
const selectAuthorContents = state => selectSliceData(state).contents

export {
  selectAuthors,
  selectAuthor,
  selectAuthorsLoaded,
  selectAuthorLoaded,
  selectAuthorContents
}
